module.exports = __webpack_public_path__ + "static/media/fehlmann.30fb7dc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/images/Logos_Lieferanten/fehlmann.png
// module id = 391
// module chunks = 0